import { createContext, useContext } from 'react';

export const MarketplaceSidebarTargetContext = createContext<HTMLDivElement | null | undefined>(undefined);

export function useMarketplaceSidebarTarget() {
    const target = useContext(MarketplaceSidebarTargetContext);
    if (target === undefined) {
        throw new Error('Marketplace sidebars require a MarketplaceSidebarTargetContext provider.');
    }
    return target;
}
